/**
 * Silent legacy product URL redirects used only to preserve backlinks.
 * These paths are not rendered in the UI.
 */
export const LEGACY_REDIRECTS: ReadonlyArray<{ from: string; to: string }> = [
  { from: '/products/zone-in-daily', to: '/products/brain-charge' },
  { from: '/products/zone-in-rest', to: '/products/brain-charge' },
  { from: '/products/zone-in-blitz', to: '/products/brain-charge' },
  { from: '/products/neurocore', to: '/products/brain-charge' },
  { from: '/products/neurocore-plus', to: '/products/brain-charge' },
  { from: '/products/neuroblitz', to: '/products/brain-charge' },
  { from: '/products/neuroblitz-xr', to: '/products/brain-charge' },
  { from: '/products/neuroblitz-xr-plus', to: '/products/brain-charge' },
  { from: '/products/neurorest', to: '/products/brain-charge' },
  { from: '/products/neurorest-xr', to: '/products/brain-charge' },
  { from: '/supplements', to: '/science' },
  { from: '/faq', to: '/products/brain-charge' },
  // Retired article describing an outdated formula — permanently points to the current product.
  { from: '/blog/quit-adderall-built-supplement-company', to: '/products/brain-charge' },
];